/** logEventGroupTypes.js
 * Author: Robert Rolland
 * Date: Tuesday, December 20, 2022
 * 
 * These are the lists of event group type ids that each
 * log section should show.
 */

export const LOG_EVENT_GROUP_TYPES = {
    driveInOut: [2, 3],
    walkInOut: [4, 5],
    trainInOut: [22]
};
  
  